import PropTypes from "prop-types";
import React from "react";
import { createUseStyles } from "react-jss";
import { InlineIcon } from "@iconify/react";
import jssVariables from "../../jss_setup";

const sliderArrowStyles = createUseStyles((props) => ({
  arrow: {
    position: "absolute!important",
    right: (props) =>
      props.icon === "fa:angle-right"
        ? `calc(${jssVariables.normal_gap} * 2)`
        : "unset",
    left: (props) =>
      props.icon === "fa:angle-left"
        ? `calc(${jssVariables.normal_gap} * 2)`
        : "unset",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1,
    color: jssVariables.colors.text.light,
    filter: (props) =>
      props.withShadow
        ? `drop-shadow(${jssVariables.shadows.title_text_shadow})`
        : "none",
    fontSize: "xxx-large",
    cursor: "pointer",
  },
}));

const SliderArrow = (props) => {
  const { icon, withShadow, onClick, id } = props;
  const classes = sliderArrowStyles({ icon, withShadow });
  return (
    <InlineIcon
      id={id}
      className={classes.arrow}
      icon={icon}
      onClick={onClick}
    />
  );
};

SliderArrow.defaultProps = {
  withShadow: false,
  id: "",
};

SliderArrow.propTypes = {
  withShadow: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  id: PropTypes.string,
};

export default SliderArrow;
